import GoogleAuth from './GAuth';
import { useEffect, useState } from 'react';
import './Modal.css'

const Modal = ({ 
    show, 
    title, 
    message, 
    warningLevel,
    onClose,
    action = null,
    actionText = null,
    actionClass = null
}) => {
    // Define styles and content based on warning level
    const getModalStyles = (level) => {
        switch (level) {
            case 0: // Error
                return {
                    iconClass: 'error',
                    icon: '❌',
                    buttonText: 'Try Again',
                    buttonClass: 'error'
                };
            case 1: // Warning
                if (action !== null) {
                    return {
                        iconClass: 'warning',
                        icon: '⚠️',
                        buttonText: 'Cancel',
                        buttonClass: 'warning'
                    };
                }

                return {
                    iconClass: 'warning',
                    icon: '⚠️',
                    buttonText: 'OK',
                    buttonClass: 'warning'
                };
            case 2: // Success
                return {
                    iconClass: 'success',
                    icon: '✓',
                    buttonText: 'Great!',
                    buttonClass: 'success'
                };
            default:
                return {
                    iconClass: 'error',
                    icon: '❌',
                    buttonText: 'OK',
                    buttonClass: 'error'
                };
        }
    };

    const modalStyles = getModalStyles(warningLevel);

    return (
        <div 
            className={`modal-overlay ${show ? 'show' : ''}`}
            onClick={onClose}
        >
            <div 
                className="modal-container"
                onClick={(e) => e.stopPropagation()}
            >
                <div className={`modal-icon ${modalStyles.iconClass}`}>
                    {modalStyles.icon}
                </div>
                <h3 className="modal-title">{title}</h3>
                <p className="modal-message">{message}</p>
                <button 
                    className={`modal-button ${modalStyles.buttonClass}`}
                    onClick={onClose}
                >
                    {modalStyles.buttonText}
                </button>

                {(action !== null) && (actionText === null) && <button className='modal-button modal-btn-confirm' onClick={action}>Confirm</button>}
                {(action !== null) && (actionText !== null) && (actionClass !== null) && <button className={"modal-button " + actionClass} onClick={action}>{actionText}</button>}
            </div>
        </div>
    );
};

const LoginModal = ({
    show,
    onClose
}) => {
    // -1: not attempted
    // 0: login failed
    // 1: login successful
    const [loginState, setLoginState] = useState(-1);

    if (!show) return null;

    return (
        <div 
            className={`modal-overlay ${show ? 'show' : ''}`}
            onClick={onClose}
        >
            <div 
                className="modal-container"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-header">
                    <h2 className="title">Login</h2>
                    <button 
                        className="modal-close-button"
                        onClick={onClose}
                        aria-label="Close modal"
                    >
                        ×
                    </button>
                </div>

                {(loginState === -1) && <div className='modal-login'>
                    <GoogleAuth loginState={loginState} setLoginState={setLoginState}/>
                </div>}

                {(loginState === 0) && <div className='modal-login'>
                    <button className='modal-button error' onClick={onClose}>Error Logging in!</button>
                </div>}

                {(loginState === 1) && <div className='modal-login'>
                    <button className='modal-button success' onClick={onClose}>Logged in!</button>
                </div>}
            </div>       
        </div>
    )
}

export {
    Modal,
    LoginModal,
} ;